import { render } from "./Statistiche.vue?vue&type=template&id=19399c84"
import script from "./Statistiche.vue?vue&type=script&lang=js"
export * from "./Statistiche.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__